import { useQuery } from 'react-query'
import { type CleaningProvider } from '#app/utils/api/types'

export const useRandomProviders = () =>
	useQuery({
		queryKey: ['randomProviders'],
		queryFn: () =>
			fetch('/resources/random-cleaning-providers').then(
				res => res.json() as Promise<CleaningProvider[]>,
			),
		refetchOnWindowFocus: () => false,
		refetchOnMount: () => false,
	})
